export default __webpack_public_path__ + "static/media/close 1.d6e16d15.svg";